import { useState } from 'react';

const useCustomerSatisfactionItem = (customerSatisfactionItem) => {
  const [state, setState] = useState({ showSurvey: false, label: 'View' });

  const onClick = (e) => {
    if (e?.preventDefault) {
      e.preventDefault();
    }

    setState({ ...state, showSurvey: true, label: state.showSurvey ? 'View' : 'Hide' });
  };

  return {
    state,
    onClick
  };
};

export default useCustomerSatisfactionItem;